import React, { useEffect, useState } from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import CountUp from 'react-countup';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import useToursStore from '../../store/tournamentsStore';
import FooterOne from '../Footer/FooterOne';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import Preloader from '../Preloader/Preloader';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'


const TournamentsPage = () => {
    pageTitle('TOURNAMENTS');

    const { tours, setTours, isLoading, setLoading} = useToursStore();

    const fetchData = async () => {
        setLoading(true);
        try {
            const querySnapshot = await getDocs(collection(db, 'tournaments'));
            const data = querySnapshot.docs.map(doc => doc.data());
            setTours(data);
            localStorage.setItem('tourLastFetchTime', Date.now().toString()); 
            localStorage.setItem('tours', JSON.stringify(data)); 
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        } finally {
            setLoading(false); 
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('tourLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000;

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };

    useEffect(() => {
        const storedTours = localStorage.getItem('tours');
        if (shouldFetchData()) {
            fetchData();
        } else if (storedTours) {
            setTours(JSON.parse(storedTours));
            setLoading(false)
        }
    }, []); 

    const [skillBar, setSkillBar] = useState(false);
    const [tourFilter, setTourFilter] = useState('all');
    const [readyTours, setReadyTours] = useState([])
    const currUsd = 0.011318;
    const date = new Date(); 
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (day <= 9) {
        day = "0" + day
    }
    if (month <= 9) {
        month = "0" + month
    }
    const nowDate = `${year}.${month}.${day}`;
    useEffect(() => {
        if (!tours || tours.length === 0) {
            return;
        }
        
        const currentTour = tours.map(data => ({
            id: data.id,
            name: data.name,
            orgName: data.orgName,
            teams: data.teams,
            prizepool: data.prizepool,
            guarantee: data.guarantee,
            openReg: data.openReg,
            link: data.link,
            image: data.image,
            currency: data.currency,
            invite: data.invite,
            regionCis: data.regionCis,
            regionEu: data.regionEu,
            closeReg: data.closeReg,
            status: nowDate < data.closeReg ? 'Register' : 'Close'
        }));
        
        const ratesTour = currentTour.map(data => ({
            ...data,
            prizepool: data.currency === 'rub' ? Math.floor(+data.prizepool * currUsd) : data.prizepool,
            currency: 'usd'
        }));
    
        ratesTour.sort((x, y) => new Date(x.closeReg) - new Date(y.closeReg));
    
        const filterTour = ratesTour.filter(data => {
        
            let linkType = ''; 
            if (data.link && data.link.includes('https://discord')) {
                linkType = 'discord';
            } else if (data.link && data.link.includes('https://t.me')) {
                linkType = 'telegram';
            }
        
            const tournamentData = {
                ...data,
                linkType: linkType
            };
        
            if (tourFilter === 'all' && tournamentData.status === 'Register') return true;
            if (tourFilter === 'cis' && tournamentData.status === 'Register' && tournamentData.regionCis == 1) return true;
            if (tourFilter === 'eu' && tournamentData.status === 'Register' && tournamentData.regionEu == 1) return true;
            if (tourFilter === 'close' && tournamentData.status === 'Close') return true;
        
            return false;
        });
        
        setReadyTours(filterTour)
        console.log(readyTours)
    }, [tours, tourFilter, nowDate, currUsd]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = readyTours.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(readyTours.length / itemsPerPage);
    
    return (
        <>
            {
                !isLoading ? <>
                
                    <Header></Header>                
                    <ScrollTrigger onEnter={()=> setSkillBar(true)} onExit={()=> setSkillBar(false)}>
                    <div className="about__page section-padding pb-100" style={{paddingBottom: '1px'}}>
                        <div className="container">
                            <div className="row mb-60">
                                <div className="col-xl-6 col-lg-8">
                                    <div className="about__page-title">
                                        <span className="subtitle">Tournaments</span>
                                        <h2>Current tournaments in different regions</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-100">
                                <div className="col-xl-12">
                                    <div className="about__page-area">
                                        <div className="about__page-area-experience">
                                            <h3>
                                                {
                                                    !readyTours ? <h1>Load...</h1> : (
                                                        <span className="counter">{skillBar && <CountUp start={0} end={readyTours.length} duration={2} delay={0}></CountUp>}</span>
                                                    )
                                                }
                                            </h3>
                                            <p>Current tournaments</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row">
                                {counterData.map((item, id)=>(
                                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6" key={id}>
                                    <div className="about__page-area-item">
                                        <h2><span className="counter">{skillBar && <CountUp start={0} end={item.id} duration={4} delay={0}></CountUp>}</span>{item.value}</h2>
                                        <p>{item.description}</p>
                                    </div>					
                                </div>
                                ))}
                            </div> */}
                        </div>
                    </div>
                    </ScrollTrigger>
                    <div className="team__area" >
                        <div className="container">
                            <div className="row mb-30 team__area-border">
                                <div className="col-xl-12">
                                    <div className="team__area-title lg-t-center">
                                        <span className="subtitle">filters</span>
                                        <h2>{tourFilter} - tournaments</h2>
                                    </div>
                                </div>
                                <div className="col-xl-12" style={{marginBottom: '8px'}}>
                                    <div className="team__area-title lg-t-center">
                                        <button onClick={() => setTourFilter('all')} style={{marginRight: '20px'}}>ALL</button>
                                        <button onClick={() => setTourFilter('cis')} style={{marginRight: '20px'}}>CIS</button>
                                        <button onClick={() => setTourFilter('eu')} style={{marginRight: '20px'}}>EU</button>
                                        <button onClick={() => setTourFilter('close')} style={{marginRight: '20px'}}>CLOSE</button>
                                    </div>
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'..'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination-tme'}
                                    activeClassName={'active'}
                                    disabledClassName={'disabled'}
                                />
                            </div>
                            <div className="row">
                                {
                                    currentItems.length == 0 ? <h1>Load...</h1> : <>
                                        {currentItems.map((item, id)=>(
                                        <div className="col-xl-3 col-lg-4 col-md-6" key={id}>
                                            <div className="team__area-item">
                                                <div className="team__area-item-image">
                                                    <img src={item.image} alt="" />
                                                    <div className="team__area-item-image-social">
                                                        <ul>
                                                            {
                                                                item.link.includes('t.me')? <li><a target='_blank' href={item.link}><i className="fab fa-telegram"></i></a> </li> : <>
                                                                    <li><a target='_blank' href={item.link}><i className="fab fa-discord"></i></a> </li>
                                                                </>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="team__area-item-content">
                                                    <h5>{item.name}</h5>
                                                    <span>date - {item.openReg} | </span>
                                                    <span>prize - {item.prizepool}$</span>
                                                </div>
                                            </div>
                                        </div>
                                        ))}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <FooterOne></FooterOne>
                </> : <Preloader />
            }
        </>
    );
};

export default TournamentsPage;